import { Link } from 'react-router-dom';

export default function FeaturedArticlesSection() {
  const articles = [
    {
      title: 'What is OOPBuy Spreadsheet?',
      desc: 'A complete introduction to the spreadsheet-based shopping system — how it started, how it works, and why it is gaining popularity worldwide.',
      link: '/blog/what-is-oopbuy-spreadsheet',
      tag: 'Beginner Guide',
      image: 'https://readdy.ai/api/search-image?query=Clean%20modern%20workspace%20with%20open%20laptop%20showing%20organized%20spreadsheet%20on%20screen%20minimalist%20desk%20setup%20with%20small%20plant%20natural%20daylight%20from%20window%20warm%20productive%20atmosphere%20editorial%20tech%20photography&width=600&height=400&seq=article-card-whatis-01&orientation=landscape',
    },
    {
      title: 'Complete OOPBuy Spreadsheet Guide',
      desc: 'Step-by-step walkthrough covering everything from browsing product sheets to placing your first order through the agent system.',
      link: '/oopbuy-spreadsheet-guide',
      tag: 'In-Depth Guide',
      image: 'https://readdy.ai/api/search-image?query=Open%20notebook%20with%20handwritten%20notes%20next%20to%20laptop%20displaying%20product%20catalog%20organized%20desk%20with%20coffee%20cup%20warm%20natural%20lighting%20learning%20education%20photography%20clean%20editorial%20style&width=600&height=400&seq=article-card-guide-02&orientation=landscape',
    },
    {
      title: 'Spreadsheet vs Traditional Agents',
      desc: 'An honest side-by-side comparison of spreadsheet-based shopping versus traditional agent communication across speed, transparency, and cost.',
      link: '/blog/oopbuy-vs-traditional-agents',
      tag: 'Comparison',
      image: 'https://readdy.ai/api/search-image?query=Split%20screen%20concept%20showing%20modern%20digital%20spreadsheet%20on%20one%20side%20and%20traditional%20paper%20notes%20on%20other%20side%20minimalist%20comparison%20visual%20clean%20editorial%20photography%20balanced%20composition&width=600&height=400&seq=article-card-compare-03&orientation=landscape',
    },
    {
      title: 'How Spreadsheet Agents Work',
      desc: 'Behind the scenes look at how agents process orders, verify products, coordinate shipping, and maintain quality control in the spreadsheet system.',
      link: '/blog/how-spreadsheet-agents-work',
      tag: 'Behind the Scenes',
      image: 'https://readdy.ai/api/search-image?query=Busy%20organized%20warehouse%20workspace%20with%20packages%20and%20shipping%20labels%20warm%20industrial%20lighting%20product%20processing%20scene%20clean%20professional%20environment%20editorial%20logistics%20photography&width=600&height=400&seq=article-card-agents-04&orientation=landscape',
    },
    {
      title: 'Is Spreadsheet Shopping Safe?',
      desc: 'Complete security analysis covering payment protection, link verification, common risks, and practical safety steps for every spreadsheet shopper.',
      link: '/blog/is-spreadsheet-shopping-safe',
      tag: 'Safety Guide',
      image: 'https://readdy.ai/api/search-image?query=Padlock%20symbol%20on%20clean%20minimalist%20desk%20with%20laptop%20in%20background%20cybersecurity%20concept%20soft%20natural%20lighting%20professional%20atmosphere%20trust%20and%20safety%20editorial%20photography&width=600&height=400&seq=article-card-safety-05&orientation=landscape',
    },
    {
      title: '10 Tips for Spreadsheet Shopping',
      desc: 'Proven strategies for browsing efficiently, comparing prices like a pro, avoiding common mistakes, and saving money on every order.',
      link: '/blog/spreadsheet-shopping-tips',
      tag: 'Tips & Tricks',
      image: 'https://readdy.ai/api/search-image?query=Checklist%20and%20coffee%20on%20light%20wooden%20desk%20with%20laptop%20showing%20spreadsheet%20in%20background%20planning%20and%20strategy%20concept%20warm%20natural%20morning%20light%20clean%20editorial%20productivity%20photography&width=600&height=400&seq=article-card-tips-06&orientation=landscape',
    },
  ];

  return (
    <section className="py-24 md:py-32 bg-background-50">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-14">
          <div>
            <span className="inline-block px-4 py-1.5 rounded-full bg-secondary-200/40 text-secondary-800 text-xs font-semibold mb-5">
              Knowledge Base
            </span>
            <h2 className="text-3xl md:text-5xl font-heading font-bold text-foreground-950 leading-[1.15] max-w-xl">
              Featured Articles &amp; Guides
            </h2>
          </div>
          <Link
            to="/oopbuy-spreadsheet-guide"
            className="text-sm font-medium text-accent-600 hover:text-accent-700 transition-colors flex items-center gap-1.5 whitespace-nowrap"
          >
            Browse All Guides
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        {/* Articles Grid with Images */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-7">
          {articles.map((article) => (
            <Link
              key={article.title}
              to={article.link}
              className="group block rounded-2xl overflow-hidden bg-background-100 border border-background-200/70 hover:border-accent-300/50 transition-all duration-300"
            >
              {/* Article Image */}
              <div className="w-full h-48 overflow-hidden bg-background-200">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              {/* Content */}
              <div className="p-6">
                <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-800 text-xs font-semibold mb-3">
                  {article.tag}
                </span>
                <h3 className="text-lg font-bold text-foreground-950 mb-2 group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                  {article.desc}
                </p>
                <div className="flex items-center gap-1.5 text-sm font-medium text-accent-600">
                  <span>Read Article</span>
                  <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>

        {/* CTA */}
        <div className="mt-14 text-center">
          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-8 py-4 rounded-full bg-primary-500 hover:bg-primary-600 transition-colors text-background-50 font-semibold text-sm whitespace-nowrap cursor-pointer"
          >
            Explore All Guides + Store
            <i className="ri-arrow-right-up-line text-lg"></i>
          </a>
        </div>
      </div>
    </section>
  );
}